import './scss/style.scss';
import {initHamburger} from './scripts/components/initHamburger';
import {enterEmailModal} from './scripts/components/modalEnterEmail';
import { initScrollToTop } from './scripts/components/initScrollToTop';
import { initScrollToAnchor } from './scripts/components/initScrollToAnchor';


window.addEventListener('load', handleOnLoadPage, false);

function handleOnLoadPage() {
    initHamburger();
    initScrollToTop();
    initScrollToAnchor();
    enterEmailModal();
}